import variant1 from 'images/icons/headerIcons/variant1.svg';
import variant2 from 'images/icons/headerIcons/variant2.svg';
import variant3 from 'images/icons/headerIcons/variant3.svg';
import variant4 from 'images/icons/headerIcons/variant4.svg';
import variant5 from 'images/icons/headerIcons/variant5.svg';
import variant6 from 'images/icons/headerIcons/variant6.svg';
import variant7 from 'images/icons/headerIcons/variant7.svg';
import variant8 from 'images/icons/headerIcons/variant8.svg';
import betino from 'images/betino.png';
import wuxal from 'images/wuxal.png';
import fertiplant from 'images/fertiplant.png';
import uniferX from 'images/uniferX.png';
import { ROUTES } from '../../constants/routes';

export const companyObject = {
    items: [
        {
            images: [variant1],
            title: 'About us',
            link: ROUTES.aboutUs,
        },
        {
            images: [variant8, variant2, variant7],
            title: 'Research, news & events',
            link: ROUTES.news,
        },
        {
            images: [variant3],
            title: 'Career',
            link: ROUTES.career,
        },
    ],
    button: '',
};

export const productsObject = {
    items: [
        {
            images: [betino],
            title: 'Organic line',
            link: ROUTES.aboutProduct,
        },
        {
            images: [wuxal],
            title: 'Wuxal',
            link: ROUTES.aboutProduct,
        },
        {
            images: [fertiplant],
            title: 'Fertiplant',
            link: ROUTES.aboutProduct,
        },
        {
            images: [uniferX],
            title: 'UniferX',
            link: ROUTES.aboutProduct,
        },
    ],
    button: {
        name: 'ALL PRODUCTS',
        link: ROUTES.products,
    },
};

export const resourcesObject = {
    items: [
        {
            images: [variant4],
            title: 'Crop nutrition programs',
            link: ROUTES.cropNutritionPrograms,
        },
        {
            images: [variant5],
            title: 'Trial results',
            link: ROUTES.trialResults,
        },
        {
            images: [variant6],
            title: 'Information materials',
            link: ROUTES.informationMaterials,
        },
    ],
    button: {
        name: 'ALL RESOURCES',
        link: ROUTES.resources,
    },
};
